import React from "react";
import PropTypes from "prop-types";
import { Router, Route, Switch } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { Spinner } from "components/Spinner";
import { EYModal } from "components/EYModal";
import { Redirect } from "react-router";
import Toaster from "components/Toaster";
import AuthorizeLink from "AuthorizeLink";
import RFETimeout from "AuthorizeLink/components/RFETimeout";
import { FormattedMessage } from "react-intl";
import UserAuthorizedContainer from "UserAuthorized/components/containers/UserAuthorizedContainer";
import RFELinkExpired from "AuthorizeLink/components/RFELinkExpired";
import RFELinkRedirection from "AuthorizeLink/components/RFELinkRedirection";
import SignSubmittedCompleted from "AuthorizeLink/components/SignSubmittedCompleted";
import { history } from "../../helpers";
const ProtectedUser = UserAuthorizedContainer;
class Main extends React.Component {
  static propTypes = {
    userInfo: PropTypes.object,
    errors: PropTypes.array
  };
  constructor(props) {
    super(props);
    this.state = {
      redirectToNoMatch: false
    };
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    //Display Error on Toaster from new Errors
    if (this.props.errors != nextProps.errors && nextProps.errors.length > 0) {
      Toaster.error(nextProps.errors[nextProps.errors.length - 1]);
    }
  }
  render() {
    const { redirectToNoMatch } = this.state;
    const { from } = { from: { pathname: "/" } };
    if (redirectToNoMatch) {
      return <Redirect to={from} />;
    }
    return (
      <React.Fragment>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
          closeButton={false}
        />
        <Router history={history}>
          <Switch>
            <Route path="/authorize/:actionKey" component={AuthorizeLink} />
            <Route path="/redirect/:actionKey/:email?/:sessionId?/:sessionHash?" component={RFELinkRedirection} />
            <Route path="/expired" component={RFELinkExpired} />
            <Route path="/completed" component={SignSubmittedCompleted} />
            <Route path="/deleted" component={RFELinkExpired} />
            <Route path="/timeout" component={RFETimeout} />
            <Route render={() => <RFELinkExpired />} />
          </Switch>
        </Router>
        <Spinner name="mySpinner">
          <FormattedMessage id={"common.loading"} />
        </Spinner>
        <EYModal />
      </React.Fragment>
    );
  }
}

Main.propTypes = {
  /**Array of current errors */
  errors: PropTypes.array
};
export default Main;
